import React from 'react'
import PropTypes from 'prop-types'

export function RessourcenPlanungGridItem({ressource, month}) {
  if (ressource) {
    const monthCount = ressource.to - ressource.from + 1
    return (
      <div className="ressourcenPlanungGridItem" data-testid={`ressourcenplanung-${month}`}>
        <div
          className={`ressourcenPlanungColSpan${monthCount} ressourcenPlanungAzubiCount`}
          data-testid={`ressourcenplanung-${month}-${monthCount}`}
        >
          {ressource.azubiCount}
        </div>
      </div>
    )
  }
  return <div className="ressourcenPlanungGridItem" data-testid={`ressourcenplanung-${month}`} />
}

RessourcenPlanungGridItem.propTypes = {
  ressource: PropTypes.object,
  month: PropTypes.number,
}

export default RessourcenPlanungGridItem
